@if (profile | async; as p) {
  @if (hasDp(p.me.contracts)) {
    <div class="app-general-infos d-flex">
      <div class="d-flex align-items-center">
        <fa-icon class="me-3" size="3x" icon="user-circle"></fa-icon>
        <div class="h-70px">
          <p class="fw-bold">Mon contact direction de projet</p>
          <div>
            <p>Mme {{ dp.firstname }} {{ dp.lastname }}</p>
            <p>
              <a href="mailto:{{dp.email}}">{{ dp.email }}</a>
              <fa-icon class="ms-2 cursor-pointer" icon="copy" appCopy="E-mail" [text]="dp.email" ngbTooltip="Copier l'adresse mail dans le presse-papier"/>
            </p>
          </div>
        </div>
      </div>
    </div>
  }
} @else {
  <div class="app-general-infos d-flex align-items-center">
    <ls-spinner/>
  </div>
}


